import { Route, Routes, useLocation } from "react-router-dom";
import LandingPage from "../../pages/LandingPage/LandingPage";
import ResourceList from "../../pages/ResourceList/ResourceList";
import GrafanaDiagram from "../../pages/Grafana/GrafanaDiagram";
import Profile from "../../pages/Profile/Profile";
import React, { useContext, useEffect } from "react";
import UploadFile from "../../pages/UploadFile/UploadFile";
import { SunriseContext } from "../../App";
import Heatmaps from "../../pages/Heatmaps/Heatmaps";
import Analysis from "../../pages/Analysis/Analysis";

const AppRoutes = ({ setTitle }) => {
  const location = useLocation();
  const { organisation } = useContext(SunriseContext);

  let routesList = [
    {
      path: "/parameters-used",
      title: "Metrics",
      element: <ResourceList />,
    },
    {
      path: "/grafana-diagram",
      title: "Demand Prediction",
      element: <GrafanaDiagram />,
    },
    {
      path: "/profile",
      title: "Profile",
      element: <Profile />,
    },
    {
      path: "/dashboard",
      title: "Dashboard",
      element: <LandingPage />,
    },
    {
      path: "/",
      title: "Dashboard",
      element: <LandingPage />,
    },
    {
      path: "/upload-file",
      title: "Upload File",
      element: <UploadFile />,
    },
    {
      path: "/heatmaps",
      title: "Heatmaps",
      element: <Heatmaps />,
    },
    {
      path: "/analysis",
      title: "Workforce Demand What-if Analysis",
      element: <Analysis />,
    },
  ];

  if (organisation === "ELS") {
    routesList = routesList.filter(
      (element) =>
        element.title !== "Upload File" && element.title !== "Metrics"
    );
  }

  if (!["RTM", "TT"].includes(organisation)) {
    routesList = routesList.filter((element) => element.title !== "Heatmaps");
  }

  if (["RTM", "TT"].includes(organisation)) {
    routesList = routesList.filter(
      (element) => element.title !== "Upload File"
    );
  }

  useEffect(() => {
    let routeItem = routesList.find((item) => item.path === location.pathname);
    if (routeItem) {
      setTitle(routeItem.title);
    }
  }, [location.pathname]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Routes>
      {/* <Route path="/login" element={<SignIn />} /> */}
      {routesList.map((item, index) => (
        <Route path={item.path} element={item.element} key={index} />
      ))}
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
};
export default AppRoutes;
